import makeTable from "./makeTable";
import BASE_WIDTH_COLUMNS from "./constants/baseWidthColumns";

const { ACTIVE } = BASE_WIDTH_COLUMNS;

const IDS = ["active", "name", "company", "branch"] as const;

const preferencesClientRefusalReasons = makeTable({
	allIds: [...IDS],
	i18tPath: (id) => `mainPage.preferences.clientRefusalReasons.columns.${id}`,
	initialSortMethod: {
		column: "active",
		type: "asc",
	},
	defaultIds: [...IDS],
	initialWidths: {
		active: ACTIVE,
		name: 450,
		company: 240,
		branch: 240,
	},
	initialResizable: {
		active: true,
		name: true,
		company: true,
		branch: true,
	},
	initialSortable: {
		active: false,
		name: false,
		company: false,
		branch: false,
	},
});

export default preferencesClientRefusalReasons;
